<!-- Phase 3: Versand-Matrix (Artikelbedarf x Versand-Config). -->
@if (!isLoading()) {
  <div class="overflow-x-auto">
    <table class="w-full text-sm border-collapse table-fixed">
      <thead>
        <tr class="border-b border-base-300">
          <th class="text-left p-2 font-semibold w-72 sticky left-0 bg-base-100 z-10">
            Artikel · Bedarf
          </th>
          @for (c of configs(); track c.id) {
            <th class="p-2 align-top overflow-hidden">
              <!-- Einheitlicher Badge-Stil fuer offene UND versandte Configs.
                   Farbe: offen/vollstaendig = primary, teilweise versandt =
                   warning. Status wird ueber das Label unter dem Badge
                   kommuniziert (kein zusaetzlicher Haken im Badge noetig). -->
              <div class="flex flex-col items-center gap-1 min-w-0">
                @if (c.shipping_status === 'open') {
                  <!-- Noch nichts versandt: editierbar (Attribute + Loeschen). -->
                  <!-- Badge oeffnet den Editor; das 🗑/🔒-Symbol sitzt INNERHALB
                       des Badges rechts (kein Zeilenumbruch). stopPropagation,
                       damit der Loeschen-Klick nicht zusaetzlich den Editor oeffnet. -->
                  <span class="bm-badge bm-badge-primary bm-badge-xs cursor-pointer h-auto max-w-full leading-tight text-center inline-flex items-center gap-1"
                        role="button" (click)="openEditor(c)" title="Config bearbeiten">
                    <span class="whitespace-normal break-words min-w-0">{{ configLabel(c) }}</span>
                    @if (canDeleteConfig(c)) {
                      <span class="shrink-0 cursor-pointer" role="button" (click)="$event.stopPropagation(); removeConfig(c.id)"
                            title="Config entfernen"><i class="fa fa-trash"></i></span>
                    } @else {
                      <span class="shrink-0 opacity-50 cursor-not-allowed" title="Nicht löschbar — bereits Sendungen vorhanden">🔒</span>
                    }
                  </span>
                } @else {
                  <!-- (Teilweise) versandt: read-only Badge. Die Lieferschein-Links
                       sitzen in den Gruppen-Header-Zeilen (Versandartikel bzw.
                       Staging-Versandartikel) neben dem jeweiligen Termin. -->
                  <span class="bm-badge bm-badge-xs h-auto max-w-full leading-tight text-center inline-flex items-center gap-1"
                        [class.bm-badge-primary]="c.archived" [class.bm-badge-warning]="!c.archived">
                    <span class="whitespace-normal break-words min-w-0">{{ configLabel(c) }}</span>
                  </span>
                }
                <!-- Zweite Zeile: Materialumbuchung (Ziel-Lager bzw. Verbraucht). -->
                <span class="text-xs text-base-content/60 truncate max-w-full" [title]="materialRebookingLabel(c)">{{ materialRebookingLabel(c) }}</span>
                <!-- Versand-/Staging-Termine stehen jetzt in den jeweiligen
                     Gruppen-Headern (Versandartikel/Staging-Versandartikel) pro
                     Config — und nur, wenn der Gruppe fuer diese Config ein
                     Artikel zugeordnet ist. -->
                @if (c.shipping_status !== 'open') {
                  <span class="text-[10px] uppercase tracking-wide font-semibold"
                        [class.text-success]="c.archived" [class.text-warning]="!c.archived">{{ c.shipping_status_label }}</span>
                }
              </div>
            </th>
          }
          @if (showStandardStaging()) {
            <th class="p-2 align-top overflow-hidden">
              <div class="flex flex-col items-center gap-1 min-w-0">
                <span class="bm-badge bm-badge-neutral bm-badge-xs h-auto max-w-full whitespace-normal break-words leading-tight text-center">Staging-Standardversand</span>
                <!-- Umbuchung: hier bewusst nur der Auftragstechniker-Name (kein Lagerplatz). -->
                <span class="text-xs text-base-content/60 truncate max-w-full"
                      [title]="'Umbuchung: ' + (operationTechnicianName || 'nicht vergeben')">Umbuchung: {{ operationTechnicianName || 'nicht vergeben' }}</span>
              </div>
            </th>
          }
          <th class="p-1 align-middle text-right w-28">
            <button class="bm-btn bm-btn-ghost bm-btn-xs whitespace-nowrap" (click)="addConfig()" title="Versand-Config hinzufügen">+ Versand</button>
          </th>
        </tr>
      </thead>
      <tbody>
        <!-- ===== VERSANDARTIKEL ===== -->
        <tr class="bg-base-200">
          <td class="px-2 py-1 sticky left-0 bg-base-200">
            <span class="font-semibold text-xs uppercase tracking-wide">
              Versandartikel
            </span>
          </td>
          <!-- Geplanter Versandtermin pro Config (nur wenn dieser Config ein
               Versandartikel zugeordnet ist) + Lieferscheine des Versands. -->
          @for (c of configs(); track c.id) {
            <td class="px-2 py-1 text-center align-middle">
              <span class="inline-flex items-center gap-1">
                @if (configHasGroupAssignment(c, 'VERSAND') && configVersandDate(c)) {
                  <span class="text-xs" title="Geplanter Versandtermin">📦 {{ configVersandDate(c) }}</span>
                }
                @if ((c.delivery_notes?.length ?? 0) > 0) {
                  <span class="cursor-pointer text-xs whitespace-nowrap" role="button" (click)="openVersandDnPopup(c)"
                        title="Lieferscheine anzeigen">{{ c.delivery_notes?.length }}x📄</span>
                }
              </span>
            </td>
          }
          @if (showStandardStaging()) {
            <td class="px-2 py-1"></td>
          }
          <td class="px-1 py-1 text-right">
            <div class="flex items-center justify-end gap-1">
              @if (versandRows().length === 0) {
                <button class="bm-btn bm-btn-info bm-btn-xs"
                        [disabled]="parsingInProgress()"
                        (click)="parseFromDescription()"
                        title="Erzeugt Versand-Artikel aus der Auftragsbeschreibung (Legacy-Format)">
                  @if (parsingInProgress()) { Parsing... } @else { Aus Auftragsbeschreibung parsen }
                </button>
              }
              <button class="bm-btn bm-btn-ghost bm-btn-xs" (click)="openAdd('VERSAND')">+ Hinzufügen</button>
            </div>
          </td>
        </tr>
        @for (req of versandRows(); track req.id) {
          <tr class="border-b border-base-200">
            <td class="p-2 sticky left-0 bg-base-100">
              <div class="flex flex-col min-w-0">
                <div class="flex items-start gap-1 min-w-0">
                  <span class="font-medium text-xs whitespace-normal break-words min-w-0">{{ reqLabel(req) }}</span>
                  <button class="bm-btn bm-btn-ghost bm-btn-xs bm-btn-square shrink-0" (click)="openEdit(req)" title="Bearbeiten">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5" viewBox="0 0 24 24"
                      fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                    </svg>
                  </button>
                  @if (canDelete(req)) {
                    <button class="bm-btn bm-btn-ghost bm-btn-xs bm-btn-square shrink-0" (click)="deleteRequirement(req)" title="Löschen">
                      <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5" viewBox="0 0 24 24"
                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                      </svg>
                    </button>
                  }
                </div>
                <span class="text-xs opacity-70">
                  Bedarf {{ req.quantity }}
                  · {{ reqArticleInfo(req) }}
                  @if (requirementFullyShipped(req)) {
                    · ✓ vollständig
                  } @else {
                    <!-- "offen N" nur, wenn tatsaechlich etwas offen ist (poolFor > 0);
                         "offen 0" der Vollstaendigkeit halber ausblenden. -->
                    @if (poolFor(req) > 0) {
                      · <span class="text-error font-semibold opacity-100">offen {{ poolFor(req) }}</span>
                    }
                    @if (lockedFloor(req) > 0) {
                      · <span class="text-warning">🔒 {{ lockedFloor(req) }}</span>
                    }
                  }
                </span>
              </div>
            </td>
            @for (c of configs(); track c.id) {
              <td class="p-2 text-center">
                @if (c.versand_shipped) {
                  <!-- VERSAND-Kanal dieser Config bereits versandt → read-only,
                       unabhaengig davon ob das Staging noch offen ist. -->
                  @if (committedShipped(c, req) > 0) {
                    <span class="text-success font-mono border border-success/60 rounded px-1.5 py-0.5" title="versandt">✓ {{ committedShipped(c, req) }}</span>
                  } @else {
                    <span class="opacity-30">—</span>
                  }
                } @else {
                  <div class="inline-flex items-center gap-1">
                    <button class="bm-btn bm-btn-xs bm-btn-square" [disabled]="!canDecrement(c, req)" (click)="decrement(c, req)">−</button>
                    <span class="w-6 text-center font-mono">{{ cellQty(c.id, req.id) }}</span>
                    <button class="bm-btn bm-btn-xs bm-btn-square" [disabled]="!canIncrement(c, req)" (click)="increment(c, req)">+</button>
                  </div>
                }
              </td>
            }
            @if (showStandardStaging()) {
              <td class="p-2 text-center opacity-30">—</td>
            }
            <td></td>
          </tr>
        }
        @if (versandRows().length === 0) {
          <tr>
            <td [attr.colspan]="configs().length + (showStandardStaging() ? 1 : 0) + 2"
                class="px-2 py-1.5 text-xs text-base-content/50">
              Kein Versandartikel definiert
            </td>
          </tr>
        }

        <!-- ===== INFO FÜR LAGERIST (notes je Config) — letzte Zeile der
             Versandartikel-Gruppe ===== -->
        <!-- Pro Config-Spalte eine Textarea (Debounce-Save). Standard-Staging-
             Spalte ist geblockt (keine Config); abgeschlossene/archivierte
             Configs sind read-only. Nur sichtbar, wenn mind. einer Config ein
             normaler Versandartikel zugeordnet ist (Notiz betrifft nur den
             normalen Versand, nicht das Staging). -->
        @if (showLageristInfo()) {
          <tr class="border-b border-base-200">
            <td class="px-2 py-1 sticky left-0 bg-base-100 align-top">
              <span class="font-semibold text-xs uppercase tracking-wide">
                Info für Lageristen
              </span>
            </td>
            @for (c of configs(); track c.id) {
              <td class="px-2 py-1 align-top">
                @if (canEditNotes(c)) {
                  <textarea
                    class="bm-textarea w-full text-xs leading-snug resize-y min-h-16"
                    rows="3"
                    placeholder="Hinweis für den Lageristen…"
                    [value]="configNotes(c.id)"
                    (input)="onNotesInput(c.id, $event)"
                  ></textarea>
                  <!-- Save-Fehler sichtbar machen statt still zu reloden;
                       die Zelle steht dann wieder auf dem Server-Stand. -->
                  @if (notesErrors().get(c.id); as notesError) {
                    <div class="text-error text-[10px] leading-snug mt-0.5">{{ notesError }}</div>
                  }
                } @else {
                  <!-- Abgeschlossene Config: Info nur noch read-only. -->
                  @if (configNotes(c.id)) {
                    <div class="text-xs whitespace-pre-wrap text-base-content/70 border border-base-200 rounded px-1.5 py-1"
                         title="Versand abgeschlossen — Info nicht mehr bearbeitbar">{{ configNotes(c.id) }}</div>
                  } @else {
                    <div class="text-center text-xs text-base-content/40"
                         title="Versand abgeschlossen — keine Info hinterlegt">—</div>
                  }
                }
              </td>
            }
            @if (showStandardStaging()) {
              <td class="px-2 py-1 align-top text-center">
                <span class="text-[10px] text-base-content/40"
                      title="Keine Config-Spalte — hier kann keine Info gesetzt werden">—</span>
              </td>
            }
            <td></td>
          </tr>
        }

        <!-- ===== STAGING-VERSANDARTIKEL ===== -->
        <tr class="bg-base-200">
          <td class="px-2 py-1 sticky left-0 bg-base-200">
            <span class="font-semibold text-xs uppercase tracking-wide">
              Staging-Versandartikel
            </span>
          </td>
          <!-- Staging-Versandtermin pro Config (nur wenn dieser Config ein
               Staging-Artikel zugeordnet ist) + Lieferscheine des Staging-Versands. -->
          @for (c of configs(); track c.id) {
            <td class="px-2 py-1 text-center align-middle">
              <span class="inline-flex items-center gap-1">
                @if (configHasGroupAssignment(c, 'STAGING')) {
                  @if (configStagingDelayDate(c)) {
                    <span class="text-xs" title="Staging-Versandtermin">📦 {{ configStagingDelayDate(c) }}</span>
                  } @else if (configStagingKw(c)) {
                    <span class="text-xs" title="Geplante Staging-Kalenderwoche">📦 KW {{ configStagingKw(c) }}</span>
                  }
                }
                @if ((c.staging_delivery_notes?.length ?? 0) > 0) {
                  <span class="cursor-pointer text-xs whitespace-nowrap" role="button" (click)="openStagingDnPopup(c)"
                        title="Lieferscheine anzeigen">{{ c.staging_delivery_notes?.length }}x📄</span>
                }
              </span>
            </td>
          }
          @if (showStandardStaging()) {
            <!-- Standard-Staging (ohne Config): geplante Staging-KW des Auftrags
                 + Lieferscheine des Standard-Stagings. -->
            <td class="px-2 py-1 text-center align-middle">
              <span class="inline-flex items-center gap-1">
                @if (standardStagingHasAssignment() && operationStagingKw()) {
                  <span class="text-xs" title="Geplante Staging-Kalenderwoche">📦 KW {{ operationStagingKw() }}</span>
                }
                @if (standardStagingDns().length > 0) {
                  <span class="cursor-pointer text-xs whitespace-nowrap" role="button" (click)="openStandardStagingDnPopup()"
                        title="Lieferscheine anzeigen">{{ standardStagingDns().length }}x📄</span>
                }
              </span>
            </td>
          }
          <td class="px-1 py-1 text-right">
            <button class="bm-btn bm-btn-ghost bm-btn-xs" (click)="openAdd('STAGING')">+ Hinzufügen</button>
          </td>
        </tr>
        @for (req of stagingRows(); track req.id) {
          <tr class="border-b border-base-200">
            <td class="p-2 sticky left-0 bg-base-100">
              <div class="flex flex-col min-w-0">
                <div class="flex items-start gap-1 min-w-0">
                  <span class="font-medium text-xs whitespace-normal break-words min-w-0">{{ reqLabel(req) }}</span>
                  <button class="bm-btn bm-btn-ghost bm-btn-xs bm-btn-square shrink-0" (click)="openEdit(req)" title="Bearbeiten">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5" viewBox="0 0 24 24"
                      fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                    </svg>
                  </button>
                  @if (canDelete(req)) {
                    <button class="bm-btn bm-btn-ghost bm-btn-xs bm-btn-square shrink-0" (click)="deleteRequirement(req)" title="Löschen">
                      <svg xmlns="http://www.w3.org/2000/svg" class="w-3.5 h-3.5" viewBox="0 0 24 24"
                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <line x1="18" y1="6" x2="6" y2="18"></line>
                        <line x1="6" y1="6" x2="18" y2="18"></line>
                      </svg>
                    </button>
                  }
                </div>
                <span class="text-xs opacity-70">
                  Bedarf {{ req.quantity }}
                  · {{ reqArticleInfo(req) }}
                  <!-- KEIN "offen" bei Staging: die nicht einer Config zugeordnete
                       Restmenge laeuft immer ueber Staging-Standardversand (Fallback),
                       gilt also stets als zugeordnet. Die Verteilung (Config vs.
                       Standard) ist in den Spalten sichtbar. -->
                  @if (requirementFullyShipped(req)) {
                    · ✓ vollständig
                  }
                </span>
              </div>
            </td>
            @for (c of configs(); track c.id) {
              <td class="p-2 text-center">
                @if (canAssign(c, req)) {
                  @if (c.staging_shipped) {
                    <!-- Staging-Kanal dieser Config ist versandt → read-only ✓N
                         (einheitlich zur Versand-Zeile), kein Stepper mehr. -->
                    @if (committedShipped(c, req) > 0) {
                      <span class="text-success font-mono border border-success/60 rounded px-1.5 py-0.5" title="versandt">✓ {{ committedShipped(c, req) }}</span>
                    } @else {
                      <span class="opacity-30">—</span>
                    }
                  } @else {
                    <!-- Noch offen: per Stepper zuweisbar; vorbereitet/zurueckgehalten angezeigt. -->
                    <div class="inline-flex items-center gap-1">
                      <button class="bm-btn bm-btn-xs bm-btn-square" [disabled]="!canDecrement(c, req)" (click)="decrement(c, req)">−</button>
                      <span class="w-6 text-center font-mono">{{ cellQty(c.id, req.id) }}</span>
                      <button class="bm-btn bm-btn-xs bm-btn-square" [disabled]="!canIncrement(c, req)" (click)="increment(c, req)">+</button>
                    </div>
                    @if (committedShipped(c, req) > 0 || committedHeld(c, req) > 0) {
                      <div class="text-[10px] leading-tight mt-0.5">
                        @if (committedShipped(c, req) > 0) {
                          <span class="text-success border border-success/60 rounded px-1" title="versandt">✓ {{ committedShipped(c, req) }}</span>
                        }
                        @if (committedHeld(c, req) > 0) {
                          <!-- Zurueckgehalten = bewusst verzoegerter Versand. Info-Warning
                               mit dem geplanten Versandtermin (staging_ship_ready_at). -->
                          <span class="text-warning block"
                                [title]="configStagingDelayDate(c) ? ('Versand bewusst verzögert zum ' + configStagingDelayDate(c)) : 'Versand vorbereitet/zurückgehalten'">
                            @if (configStagingDelayDate(c)) {
                              ⏸️ verzögert zum {{ configStagingDelayDate(c) }}
                            } @else {
                              ⏸️ {{ committedHeld(c, req) }}
                            }
                          </span>
                        }
                      </div>
                    }
                  }
                } @else {
                  <span class="opacity-30" title="Dieser Versandtyp deckt keine Staging-Artikel ab">—</span>
                }
              </td>
            }
            @if (showStandardStaging()) {
              <td class="p-2 text-center">
                <span class="font-mono">{{ poolFor(req) }}</span>
                @if (standardStagingShipped(req) > 0 || standardStagingDelayed(req) > 0) {
                  <div class="text-[10px] leading-none mt-0.5">
                    @if (standardStagingShipped(req) > 0) {
                      <span class="text-success border border-success/60 rounded px-1" title="versandt">✓ {{ standardStagingShipped(req) }}</span>
                    }
                    @if (standardStagingDelayed(req) > 0) {
                      <span class="text-warning" title="vorbereitet/verzögert">⏸️ {{ standardStagingDelayed(req) }}</span>
                    }
                  </div>
                }
              </td>
            }
            <td></td>
          </tr>
        }
        @if (stagingRows().length === 0) {
          <tr>
            <td [attr.colspan]="configs().length + (showStandardStaging() ? 1 : 0) + 2"
                class="px-2 py-1.5 text-xs text-base-content/50">
              Kein Staging-Artikel definiert
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
  @if (isSaving()) {
    <div class="text-xs text-base-content/50 mt-1">Speichere …</div>
  }
}

<!-- Config-Editor: bestehendes Versandconfig-Form als Modal-Popover. -->
@if (editingConfig() || creatingConfig()) {
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4" (click)="closeEditor()">
    <div class="bm-card bg-base-100 w-full max-w-3xl max-h-[90vh] overflow-y-auto shadow-xl"
         (click)="$event.stopPropagation()">
      <div class="bm-card-body p-4">
        <hawk-shipping-config-form
          [initialConfig]="editingConfig()"
          [context]="editorContext()"
          [ticketStoreId]="ticketStoreId"
          [ticketLat]="ticketLat"
          [ticketLng]="ticketLng"
          [referenceDate]="referenceDate"
          [projectId]="projectId"
          [operationTechnicianId]="operationTechnicianId"
          [operationTechnicianName]="operationTechnicianName"
          [heading]="creatingConfig() ? 'Versand-Config anlegen' : 'Versand-Config bearbeiten'"
          [saveLabel]="creatingConfig() ? 'Anlegen' : 'Speichern'"
          [stagingArticlesAssigned]="editingConfigHasStaging()"
          (save)="onEditorSave($event)"
          (cancel)="closeEditor()"
        />
      </div>
    </div>
  </div>
}

<!-- Lieferschein-Popup (Versand-, Staging- oder Standard-Staging-Lieferscheine). -->
@if (dnPopup(); as popup) {
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4" (click)="closeDnPopup()">
    <div class="bg-base-100 rounded-lg shadow-xl w-full max-w-lg p-5 flex flex-col gap-3"
         (click)="$event.stopPropagation()">
      <div class="flex items-center justify-between gap-2">
        <h3 class="font-bold text-base shrink-0">{{ popup.title }}</h3>
        <span class="bm-badge bm-badge-primary bm-badge-xs h-auto max-w-full min-w-0 whitespace-normal break-words leading-tight text-center">{{ popup.badge }}</span>
      </div>
      <div class="flex flex-col gap-2">
        @for (dn of popup.notes; track dn.id) {
          <a class="bm-btn bm-btn-ghost bm-btn-sm justify-start"
             [routerLink]="['/', 'lieferscheine', dn.id]" target="_blank" (click)="closeDnPopup()">
            📄 {{ dn.number || dn.id }}
          </a>
        }
      </div>
      <div class="flex justify-end pt-2 border-t border-base-200">
        <button class="bm-btn bm-btn-ghost bm-btn-sm" (click)="closeDnPopup()">Schließen</button>
      </div>
    </div>
  </div>
}

<!-- Artikel-Modal (Anlegen/Bearbeiten von Versand- bzw. Staging-Artikeln). -->
@if (showModal()) {
  <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/40" (mousedown)="onBackdropClick($event)">
    <div class="bg-base-100 rounded-lg shadow-xl w-full max-w-3xl mx-4 p-5 flex flex-col gap-4">
      <h3 class="font-bold text-base">
        {{ editingRequirement() ? (formActionType === "STAGING" ? "Staging-Artikel bearbeiten" : "Versand-Artikel bearbeiten")
                                 : (formActionType === "STAGING" ? "Staging-Artikel hinzufügen" : "Versand-Artikel hinzufügen") }}
      </h3>

      <!-- Menge + Artikelvorlage in einer Zeile -->
      <div class="flex gap-3 items-start">
        <div class="w-24 shrink-0">
          <label class="bm-label text-xs mb-1">Menge</label>
          <input
            type="number"
            class="bm-input bm-input-sm w-full"
            [(ngModel)]="formQuantity"
            [min]="formMinQuantity()"
          />
          @if (formMinQuantity() > 1) {
            <span class="text-xs opacity-60 mt-1 block">
              Mind. {{ formMinQuantity() }} (bereits versandt)
            </span>
          }
        </div>

        <div class="flex-1 min-w-0">
          <label class="bm-label text-xs mb-1">
            @if (formActionType === "STAGING") {
              Artikelvorlage
            } @else {
              Artikelvorlage/Freitext
            }
          </label>
          <div class="relative">
            @if (formActionType === "STAGING") {
              <select
                class="bm-select bm-select-sm w-full"
                [(ngModel)]="formStagingTemplateId"
                (ngModelChange)="onStagingTemplateSelect($event)"
              >
                <option [ngValue]="null">Artikelvorlage wählen...</option>
                @for (tpl of stagingTemplates(); track tpl.id) {
                  <option [ngValue]="tpl.id">{{ tpl.description }}</option>
                }
              </select>
            } @else {
              <input
                type="text"
                class="bm-input bm-input-sm w-full"
                [(ngModel)]="formSearchText"
                (input)="onSearchInput()"
                (blur)="onSearchBlur()"
                placeholder="Artikelvorlage suchen oder Freitext..."
              />
              @if (searchResults().length > 0) {
                <div class="absolute z-10 w-full mt-1 border border-base-300 rounded bg-base-100 shadow-lg max-h-40 overflow-y-auto">
                  @for (result of searchResults(); track result.id) {
                    <div
                      class="px-3 py-1.5 text-sm cursor-pointer hover:bg-base-200"
                      (mousedown)="selectTemplate(result)"
                    >
                      {{ result.description }}
                      @if (result.part_nr) {
                        <span class="text-base-content/50">({{ result.part_nr }})</span>
                      }
                    </div>
                  }
                </div>
              }
            }
          </div>
        </div>
      </div>

      <!-- Aktionen -->
      <div class="flex gap-2 justify-end pt-2 border-t border-base-200">
        <button class="bm-btn bm-btn-ghost bm-btn-sm" (click)="closeModal()">Abbrechen</button>
        <button class="bm-btn bm-btn-primary bm-btn-sm" [disabled]="!canSave()" (click)="saveRequirement()">
          Speichern
        </button>
      </div>
    </div>
  </div>
}
